import { useContext, useEffect, useState } from "react"

import useMountEffect from "@p-ban/common/src/hooks/useMountEffect"
import usePrevious from "@p-ban/common/src/hooks/usePrevious"

import * as oneClickIs from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"
import type { ProcurementValues } from "../../../types/params"
import OneClickEstimateContext from "../../OneClickEstimateContext"

const getProcurementValues = () => {
  const localStorageMapkey = new URLSearchParams(window.location.search).get("localStorageMapkey")

  if (localStorageMapkey === null) return null

  return { localStorageMapkey }
}

const usePartsProcurement = (
  values: Pick<
    EstimateValues,
    | "serviceD"
    | "serviceM"
    | "serviceG"
    | "partsProcurementCourse"
    | "sheetCnt"
    | "panelizedItemCnt"
    | "panelizedItemKindCnt"
  >,
) => {
  const { partsListMapkey } = useContext(OneClickEstimateContext)
  const [procurementValues, setProcurementValues] = useState<ProcurementValues>({
    localStorageMapkey: "",
  })

  useMountEffect(() => {
    const values = getProcurementValues()
    if (values !== null) {
      setProcurementValues(values)
    }
  })

  useEffect(() => {
    if (partsListMapkey) {
      setProcurementValues({
        localStorageMapkey: partsListMapkey,
      })
    }
  }, [partsListMapkey])

  const isProcurement = oneClickIs.isProcurement(values)
  const prevIsProcurement = usePrevious(isProcurement)
  useEffect(() => {
    if (prevIsProcurement && !isProcurement) {
      setProcurementValues({
        localStorageMapkey: "",
      })
    }
  }, [isProcurement, prevIsProcurement])

  return {
    procurementValues,
  }
}

export default usePartsProcurement
